import { useContext, useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Card from "@mui/material/Card";

// MindPlus components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// MindPlus examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import dataTableData from "layouts/programs/sessions-list/data/dataTableData";

import DataTable from "examples/Tables/DataTable";
import { NavLink, useParams } from "react-router-dom";
import AddSessionPopup from "layouts/programs/sessions-list/components/AddSessionPopup";
import { DataContext } from "context/dataContext";

function SessionsList() {
  const params = useParams();

  const [data, setData] = useState({ ...dataTableData, rows: [] });

  const { dataState, getSessionsApi, updateProgramApi } = useContext(DataContext);

  const [sessions, setSessions] = useState([]);
  const [programName, setProgramName] = useState("");
  const [popupState, setPopupState] = useState(false);

  const addSession = () => {
    setPopupState(true);
    console.log("Add Session clicked");
  };

  useEffect(() => {
    console.log("params", params);
    getSessionsApi(params.id).then((res) => {
      console.log("getSessionsApi", res);

      if (res && res.success) {
        let resData = res?.data.data;
        //console.log("getSessionsApi resData", resData);
        setSessions(resData);
        console.log(resData);
        setData((prevData) => ({
          ...prevData,
          rows: resData.map((session) => {
            return {
              ...session,
            };
          }),
        }));
      } else {
        console.log("Something went wrong");
      }
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={12}>
            <MDBox mb={2}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={6}>
                  <MDTypography variant="h4" fontWeight="medium">
                    Add Sessions to Program: {programName}
                  </MDTypography>
                  <MDBox mt={1}>
                    <MDTypography variant="body2" color="text">
                      Add & manage sessions of the program. The program is auto saved after adding
                      each session.
                    </MDTypography>
                  </MDBox>
                </Grid>
                <Grid item xs={12} lg={6} sx={{ textAlign: "right" }}>
                  <MDButton variant="gradient" color="dark" onClick={addSession}>
                    Add Session
                  </MDButton>
                  {/* <MDButton variant="gradient" color="primary" onClick={saveProgram} sx={{ ml: 2 }}>
                    Save Program
                  </MDButton> */}
                </Grid>
              </Grid>
            </MDBox>
            <Card>
              {data.rows.length > 0 ? (
                <DataTable table={data} canSearch />
              ) : (
                <MDBox p={2}>
                  <MDTypography>No Data</MDTypography>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <AddSessionPopup open={popupState} close={setPopupState} />
      <Footer />
    </DashboardLayout>
  );
}

export default SessionsList;
